import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { mspFileInterface } from 'src/app/util/interfaces/mspFile';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class CmdbRegisterPageAttachmentService {
	private readonly http = inject(HttpClient);
	private readonly AuthLoginService = inject(AuthLoginService);

	private getFileListUrl = environment.baseApiUrl + 'cmdb/{idCi}/file';
	private getFileUrl = environment.baseApiUrl + 'cmdb/{idCi}/file?file_id={idFile}';
	private postUploadFileUrl = environment.baseApiUrl + 'cmdb/{idCi}/file';
	private deleteFileUrl = environment.baseApiUrl + 'cmdb/{idCi}/file/{idFile}';

	constructor() {}

	getFileList(idCi: string): Observable<mspFileInterface[]> {
		const getFileListUrl = this.getFileListUrl.replace('{idCi}', idCi);
		return this.http.get<any[]>(getFileListUrl, { headers: this.AuthLoginService.getHttpHeaders() }).pipe(
			map((fileListRes) => {
				const newMspFileList: mspFileInterface[] = [];
				for (const fileRes of fileListRes) {
					const newMspFile: mspFileInterface = {
						file_path: fileRes.fileAttach,
						id: fileRes.id,
						checkSum: fileRes.checksum,
						content: '',
						extension: '',
						mimeType: '',
						size: 0,
						name: fileRes.fileName,
					};

					newMspFileList.push(newMspFile);
				}

				return newMspFileList;
			})
		);
	}

	getFile(idCi: string, idFile: string): Observable<mspFileInterface> {
		const getFileUrl = this.getFileUrl.replace('{idCi}', idCi).replace('{idFile}', idFile);
		return this.http.get<mspFileInterface>(getFileUrl, { headers: this.AuthLoginService.getHttpHeaders() });
	}

	uploadFiles(idCi: string, mspFiles: mspFileInterface): Observable<mspFileInterface> {
		const postUploadFileUrl = this.postUploadFileUrl.replace('{idCi}', idCi);
		return this.http.post<mspFileInterface>(postUploadFileUrl, mspFiles, { headers: this.AuthLoginService.getHttpHeaders() });
	}

	deleteFile(idCi: string, idFile: string): Observable<any> {
		const deleteFileUrl = this.deleteFileUrl.replace('{idCi}', idCi).replace('{idFile}', idFile);
		return this.http.delete<any>(deleteFileUrl, { headers: this.AuthLoginService.getHttpHeaders() });
	}
}
